import React, { useState, useEffect } from 'react';
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  Tabs,
  TextField,
  Fade,
  Box,
  Link,
  Tooltip
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useHistory, useParams, withRouter } from 'react-router-dom';
import { useTheme } from '@material-ui/styles';
import Notification from '../../utils/notification';
// styles
import useStyles from './styles';

// logo
import logoEscuro from '../../images/logo-escuro.png';
import logoBranco from '../../images/logo-branco.png';

// context
import { useUserDispatch, loginUser } from '../../context/UserContext';
import isMobile from '../../utils/isMobile';
import api from '../../services/api';
import { getError } from '../../utils/getResponseError';

import logoDev from '../../images/logo-dev.png';

function Login(props) {
  const classes = useStyles();
  const theme = useTheme();
  const params = useParams();
  const history = useHistory();

  const { token } = params;

  // global
  const userDispatch = useUserDispatch();

  // local
  const [isLoading, setIsLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [error, setError] = useState(null);
  const [errorText, setErrorText] = useState(null);
  const [activeTabId, setActiveTabId] = useState(0);
  const [loginValue, setLoginValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmaSenha, setConfirmaSenha] = useState('');
  const [mobile, setMobile] = useState(isMobile(window, theme));

  function mobileVerify() {
    setMobile(isMobile(window, theme));
  }

  useEffect(() => {
    if (token) {
      setActiveTabId(2);
    }
    window.addEventListener('resize', mobileVerify);
    return function cleanup() {
      window.removeEventListener('resize', mobileVerify);
    };
  });

  function handlePage(page) {
    setError(null);
    setSucesso(false);
    setActiveTabId(page);
  }

  async function handleResetPassword() {
    setError(null);
    setIsLoading(true);
    try {
      await api.post('/usuario/forgot-senha', {
        email: loginValue
      });
      setSucesso(true);
    } catch (error) {
      setError(true);
      setErrorText(getError(error));
    }
    setIsLoading(false);
  }

  async function handleUpdatePass() {
    setError(null);
    setIsLoading(true);
    try {
      if (novaSenha !== confirmaSenha) {
        setError(true);
        setIsLoading(false);
        return setErrorText('A confirmação da senha é de diferente da senha informada');
      }

      await api.post('/usuario/reset-senha', {
        email: loginValue,
        senha: novaSenha,
        token
      });
      setSucesso(true);
    } catch (error) {
      setError(true);
      setErrorText(getError(error));
    }
    setIsLoading(false);
  }

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img src={logoBranco} alt="logo" className={classes.logotypeImage} />
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          {mobile && (
            <img src={logoEscuro} alt="logo" className={classes.logotypeImageMobile} />
          )}
          <Tabs
            value={activeTabId}
            onChange={(e, id) => setActiveTabId(id)}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {/* <Tab label="Login" classes={{ root: classes.tab }} /> */}
            {/* <Tab label="New User" classes={{ root: classes.tab }} /> */}
          </Tabs>
          {activeTabId === 0 && (
            <>
              {/* <Typography variant="h1" className={classes.greeting}>
                Good Morning, User
              </Typography>
              <Button size="large" className={classes.googleButton}>
                <img src={google} alt="google" className={classes.googleIcon} />
                &nbsp;Sign in with Google
              </Button> */}
              <div className={classes.formDividerContainer}>
                <div className={classes.formDivider} />
                <Typography className={classes.formDividerWord}>LOGIN</Typography>
                <div className={classes.formDivider} />
              </div>
              <form onSubmit={(e) => {
                e.preventDefault();
                loginUser(
                  userDispatch,
                  loginValue,
                  passwordValue,
                  props.history,
                  setIsLoading,
                  setError,
                  setErrorText
                );
              }}
              >
                <TextField
                  id="email"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={loginValue}
                  onChange={(e) => setLoginValue(e.target.value)}
                  margin="normal"
                  placeholder="Email"
                  type="email"
                  fullWidth
                  disabled={isLoading}
                  required
                />
                <TextField
                  id="password"
                  InputProps={{
                    minLength: 8,
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    }
                  }}
                  value={passwordValue}
                  onChange={(e) => setPasswordValue(e.target.value)}
                  margin="normal"
                  placeholder="Senha"
                  type="password"
                  fullWidth
                  disabled={isLoading}
                  required
                />
                <Fade in={error}>
                  <Box mt={2}>
                    <Alert severity="error">{errorText}</Alert>
                  </Box>
                </Fade>

                <div className={classes.formButtons}>
                  {isLoading ? (
                    <CircularProgress size={26} className={classes.loginLoader} />
                  ) : (
                    <Button
                      disabled={
                        loginValue.length === 0 || passwordValue.length === 0
                      }
                      variant="contained"
                      color="primary"
                      size="large"
                      type="submit"
                    >
                      Login
                    </Button>
                  )}
                  <Button
                    disabled={isLoading}
                    color="primary"
                    size="large"
                    className={classes.forgetButton}
                    onClick={() => handlePage(1)}
                  >
                    Esqueceu a senha?
                  </Button>
                </div>
              </form>

            </>
          )}
          {activeTabId === 1 && (
            <>
              {/* <Typography variant="h1" className={classes.greeting}>
                Welcome!
              </Typography> */}
              <div className={classes.formDividerContainer}>
                <div className={classes.formDivider} />
                <Typography className={classes.formDividerWord}>RECUPERAR SENHA</Typography>
                <div className={classes.formDivider} />
              </div>
              <TextField
                id="email"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                margin="normal"
                placeholder="Email"
                type="email"
                fullWidth
              />
              <Fade in={error}>
                <Box mt={2}>
                  <Alert severity="error">{errorText}</Alert>
                </Box>
              </Fade>
              {sucesso && (
                <Alert severity="success">
                  Link de recuperação enviado, expira em 1 hora.
                </Alert>
              )}
              <div className={classes.formButtons}>
                {isLoading ? (
                  <CircularProgress size={26} className={classes.loginLoader} />
                ) : (
                  <Button
                    disabled={
                      loginValue.length === 0
                    }
                    onClick={handleResetPassword}
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Solicitar
                  </Button>
                )}
                <Button
                  color="primary"
                  size="large"
                  className={classes.forgetButton}
                  onClick={() => handlePage(0)}
                >
                  Fazer login
                </Button>
              </div>
              {/* <div className={classes.formDividerContainer}>
                <div className={classes.formDivider} />
                <Typography className={classes.formDividerWord}>or</Typography>
                <div className={classes.formDivider} />
              </div>
              <Button
                size="large"
                className={classnames(
                  classes.googleButton,
                  classes.googleButtonCreating,
                )}
              >
                <img src={google} alt="google" className={classes.googleIcon} />
                &nbsp;Sign in with Google
              </Button> */}
            </>
          )}
          {activeTabId === 2 && (
            <>
              {/* <Typography variant="h1" className={classes.greeting}>
                Welcome!
              </Typography> */}
              <div className={classes.formDividerContainer}>
                <div className={classes.formDivider} />
                <Typography className={classes.formDividerWord}>ATUALIZAR SENHA</Typography>
                <div className={classes.formDivider} />
              </div>
              <TextField
                id="email"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                margin="normal"
                placeholder="Email"
                type="email"
                fullWidth
              />
              <TextField
                id="password"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                margin="normal"
                placeholder="Nova senha"
                type="password"
                fullWidth
                disabled={isLoading}
              />
              <TextField
                id="password"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={confirmaSenha}
                onChange={(e) => setConfirmaSenha(e.target.value)}
                margin="normal"
                placeholder="Confirmar senha"
                type="password"
                fullWidth
                disabled={isLoading}
              />
              {sucesso && (
                <Alert severity="success">
                  Senha atualizada, faça login
                </Alert>
              )}
              <Fade in={error}>
                <Box mt={2}>
                  <Alert severity="error">{errorText}</Alert>
                </Box>
              </Fade>
              <div className={classes.formButtons}>
                {isLoading && (
                  <CircularProgress size={26} className={classes.loginLoader} />
                )}
                {!sucesso && !isLoading && (
                  <Button
                    disabled={
                      loginValue.length === 0 || novaSenha.length === 0 || confirmaSenha.length === 0
                    }
                    onClick={handleUpdatePass}
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Atualizar senha
                  </Button>
                )}
                {!isLoading && sucesso && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => {
                      setActiveTabId(0);
                      history.replace('/login');
                    }}
                  >
                    Fazer login
                  </Button>
                )}
              </div>
            </>
          )}
        </div>
        <Typography color="primary" className={classes.copyright} align="center">
          © 2021-
          {new Date().getFullYear()}
          {' '}
          <a style={{ textDecoration: 'none', color: 'inherit' }} href="#" rel="noopener noreferrer" target="_blank">AlphasTech</a>
          <br />
          <br />
          <Link
            color="primary"
            href="https://wa.me/5583996800612"
            target="_blank"
            className={classes.link}
          >
            <Tooltip
              title="Desenvolvido por Fernando Neto"
              aria-label="dev-fernando"
              placement="left-center"
            >
              <img
                src={logoDev}
                alt="Fernando"
                className={classes.dev}
                aria-label="dev-fernando"
              />
            </Tooltip>
          </Link>
        </Typography>
      </div>
    </Grid>
  );
}

export default withRouter(Login);
